<template>
  <div class="hello">
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>客户</el-breadcrumb-item>
          <el-breadcrumb-item>项目</el-breadcrumb-item>
          <el-breadcrumb-item>存档花名册</el-breadcrumb-item>
          <el-breadcrumb-item>导出记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-tabs
        v-model="activeName"
        type="card"
        @tab-click="handleClick"
        class="p_roster_table"
      >
        <!-- 招聘角色不能看雇员花名册 -->
        <el-tab-pane
          label="项目列表"
          name="项目列表"
          v-if="checkPermission(['customerList_tab_list'], permissionLists)"
        ></el-tab-pane>
        <el-tab-pane
          label="在职"
          name="在职"
          v-if="checkPermission(['customerList_tab_onjob'], permissionLists)"
        ></el-tab-pane>
        <el-tab-pane
          label="离职"
          name="离职"
          v-if="checkPermission(['customerList_tab_depart'], permissionLists)"
        ></el-tab-pane>
        <el-tab-pane
          label="离职转正"
          name="离职转正"
          v-if="
            checkPermission(['customerList_tab_transform'], permissionLists)
          "
        ></el-tab-pane>
        <el-tab-pane
          label="自离"
          name="自离"
          v-if="
            checkPermission(['customerList_tab_selfdepart'], permissionLists)
          "
        ></el-tab-pane>
        <el-tab-pane
          label="黑名单雇员"
          name="黑名单雇员"
          v-if="
            checkPermission(['customerList_tab_blacklist'], permissionLists)
          "
        ></el-tab-pane>
        <el-tab-pane
          label="导入导出记录"
          name="导入导出记录"
          v-if="
            checkPermission(['customerList_import'], permissionLists) ||
            checkPermission(['customerList_export'], permissionLists)
          "
        ></el-tab-pane>
      </el-tabs>
      <div
        class="expRecordTable"
        v-if="checkPermission(['customerList_export'], permissionLists)"
      >
        <el-table
          :data="tableData"
          :max-height="tableHeight - 180"
          v-loading="listLoading"
          element-loading-text="导出记录生成中"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column align="center" label="序号" width="50">
            <template slot-scope="{ $index }">
              <span>{{
                (Number(infoQuery.currpage) - 1) * Number(infoQuery.pagecount) +
                Number($index) +
                1
              }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="服务中心" prop="StrServCentName" min-width="12%"></el-table-column> -->
          <el-table-column
            align="center"
            label="项目名称"
            prop="StrOutCustName"
            min-width="23%"
          >
            <template slot-scope="{ row }">
              <span v-if="row.StrOutCustName == 'cardid'">身份证到期提醒</span>
              <span v-else-if="row.StrOutCustName == 'test'"
                >试用期到期提醒</span
              >
              <span v-else-if="row.StrOutCustName == 'cont'">合同到期提醒</span>
              <span v-else-if="row.StrOutCustName == 'age16'"
                >16周岁以下未成年提醒</span
              >
              <span v-else-if="row.StrOutCustName == 'age18'"
                >16~18周岁未成年提醒</span
              >
              <span
                v-else-if="
                  row.StrOutCustName == 'oldman' ||
                  row.StrOutCustName == 'oldwoman'
                "
                >退休提醒</span
              >
              <span v-else-if="row.StrOutCustName == 'oldage'">65周岁提醒</span>
              <span v-else-if="row.StrOutCustName == 'hurt'">工伤纠纷提醒</span>
              <span v-else>{{ row.StrOutCustName }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="业务立项部门" prop="StrImpInstName" min-width="15%"></el-table-column> -->
          <!-- <el-table-column align="center" label="负责客服" prop="StrServUsrName" min-width="15%"></el-table-column> -->
          <el-table-column
            align="center"
            label="格式"
            prop="DtImpDate"
            min-width="16%"
          >
            <template>xlsx</template>
          </el-table-column>
          <el-table-column
            align="center"
            label="操作人员"
            prop="Username"
            width="100px"
          ></el-table-column>
          <el-table-column
            align="center"
            label="操作时间"
            prop="DtImpDate"
            min-width="16%"
          >
            <template slot-scope="{ row }">
              <span>{{
                row.DtImpDate.replace(/T/, " ").substring(0, 19)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态" min-width="16%">
            <template slot-scope="scope">
              <span v-if="scope.row.path">已生成</span>
              <span
                v-if="
                  isNull(scope.row.path) &&
                  new Date().getTime() <
                    new Date(
                      new Date(
                        scope.row.DtImpDate.length >= 19
                          ? scope.row.DtImpDate.substring(0, 19)
                          : scope.row.DtImpDate
                      ).valueOf() +
                        (scope.row.StrOutCustName.indexOf('全员导出') == -1
                          ? 360000
                          : 1200000)
                    ).getTime()
                "
              >
                <i class="el-icon-loading"></i>
                <span>正在生成中</span>
              </span>
              <span
                v-if="
                  new Date().getTime() >
                    new Date(
                      new Date(
                        scope.row.DtImpDate.length >= 19
                          ? scope.row.DtImpDate.substring(0, 19)
                          : scope.row.DtImpDate
                      ).valueOf() +
                        (scope.row.StrOutCustName.indexOf('全员导出') == -1
                          ? 360000
                          : 1200000)
                    ).getTime() && isNull(scope.row.path)
                "
              >
                <span>导出失败</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            prop="StrOperType"
            min-width="13%"
          >
            <template slot-scope="scope">
              <!-- <a href='https://zhishiexcel.obs.myhuaweicloud.com/'  + scope.row.path>下载</a> -->
              <a :href="scope.row.path" v-if="scope.row.path">下载</a>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-show="totalcount > 0 && qStstus == ''">
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page.sync="infoQuery.currpage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total,sizes,prev,pager, next, jumper"
            :total="totalcount"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import xz from "@/common";
import checkPermission from "@/utils/permission"; // 权限判断函数
export default {
  name: "HelloWorld",
  props: {
    toPermissionLists: {
      type: Array,
      default() {
        return {};
      },
    },
    custname: {
      type: String,
      default() {
        return "";
      },
    },
    qStstus: {
      type: String,
      default() {},
    },
  },
  data() {
    return {
      activeName: "",
      //角色类型
      roleType: "",
      tablePath: this.$store.state.EMP.tablePath,
      tableHeight: 0,
      listLoading: false,
      currpage: 1,
      totalcount: null,
      //下拉筛选
      showDropScreen: -1,
      currentPage3: 1,
      currentPage1: 1,
      tableData: [],
      // 是否能看项目列表
      isCanProList: false,
      infoQuery: {
        pagecount: 10,
        currpage: 1,
        tableid: "XZ_emp_UserBase,XZ_emp_UserBasenewout",
        custname: "",
        datestart: "",
        dateend: "",
      },
      pagecount: 10,
      pageSize: 10,
      //定时器
      interval: null,
      permissionLists: [],
    };
  },
  // props:['custname','qStstus'],
  created() {
    let that = this
    this.roleType = localStorage.loginRoletype;
    this.calHeight();
    this.$nextTick(() => {
      that.printButton(that.toPermissionLists);
    });
  },
  mounted() {
    // this.getExportRecord();
    // console.log('d',this.custname)
    // this.getlastexp();
    // console.log('qStstus',this.qStstus)
  },
  methods: {
    checkPermission,
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
      // console.log("height", this.tableHeight);
    },
    // 父组件传值按钮权限给子组件的值
    printButton(val) {
      // console.log('printButton', val)
      let that = this;
      that.permissionLists = val;
      if (!that.isNull(val)) {
        if (
          that.checkPermission(["customerList_import"], that.permissionLists) ||
          that.checkPermission(["customerList_export"], that.permissionLists)
        ) {
          that.activeName = "导入导出记录";
          that.qStstus ? that.timeOut() : that.getExportRecord(that.infoQuery);
        } else {
          that.activeName = "";
        }
      } else {
        that.activeName = "";
      }
    },
    //切换tab
    async handleClick(tab, event) {
      this.activeName = tab.name;
      if (tab.name == "项目列表") {
        this.$router.push({
          path: "/customerList",
          query: {
            currname: "项目列表",
          },
        });
      } else if (
        tab.name == "在职" ||
        tab.name == "离职" ||
        tab.name == "离职转正" ||
        tab.name == "自离"
      ) {
        this.$router.push({
          path: "/customerList",
          query: {
            currname: tab.name,
          },
        });
      } else {
        if (tab.name == "黑名单雇员") {
          this.$router.push({
            path: "/blacklist",
            query: {
              currname: "黑名单雇员",
            },
          });
        }
        if (tab.name == "导入导出记录") {
          this.qStstus ? this.timeOut() : this.getExportRecord(this.infoQuery);
        }
      }
    },
    //确保生成的一条数据是最新导出的
    timeOut() {
      this.listLoading = true;
      setTimeout(() => {
        this.getlastexp();
      }, 3000);
    },
    //判断是否为空(包含0)
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == 0 ||
        o == "NaN"
      );
    },
    //翻页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currpage = `${val}`;
      this.infoQuery.currpage = val;
      this.getExportRecord(this.infoQuery);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.infoQuery.pagecount = `${val}`;
      this.pageSize = parseInt(val);
      this.getExportRecord(this.infoQuery);
    },
    //获取最新一条导出记录
    async getlastexp() {
      clearInterval(this.interval);
      var custname = this.custname;
      this.listLoading = true;
      xz.getLastExpData(custname).then((res) => {
        //  console.log('res',res)
        this.tableData = [];
        if (res && res != "没有记录！") {
          //  res.DtImpDate = res.DtImpDate.substring(0,10).replace(/-/, "/").replace(/-/, "/");
          this.tableData.push(res);
          if (res.StrOutPath) {
            var d = res.StrOutPath;
            d = d.replace('"', "").replace('"', "");
            var path = this.tablePath + d;
            this.$set(this.tableData[0], "path", path);
            this.clear();
          } else {
            this.interval = setInterval(this.getlastexp, 10000);
          }
          this.listLoading = false;
        } else {
          //清除定时器
          // clearInterval(this.interval);
          // this.interval = null
          this.listLoading = true;
          this.tableData = [];
          this.interval = setInterval(this.getlastexp, 10000);
          //  this.clear()
        }
      });
    },
    //查询导出进度
    getexpPro() {
      xz.getExpProcess(this.custname).then((res) => {
        if (res == "100") {
          clearInterval(this.interval);
          this.$set(this.tableData[0], "status", res);
          xz.getLastExpData(this.custname).then((result) => {
            console.log("a", result.StrOutPath);
            if (result) {
              var d = result.StrOutPath;
              d = d.replace('"', "").replace('"', "");
              var path = this.tablePath + d;
              this.$set(this.tableData[0], "path", path);
              // console.log('a',this.tableData)
            }
          });
        }
      });
    },
    //导出记录历史
    getExportRecord(data) {
      // const data={
      //   currpage:this.currpage,
      //   pagecount:10,
      //   custname:this.custname
      // }
      this.listLoading = true;
      this.infoQuery = data;
      xz.getExpRec(data).then((res) => {
        console.log("res", res);
        if (res.msg.length > 0) {
          res.msg.forEach((l) => {
            //  l.DtImpDate = l.DtImpDate.substring(0,10).replace(/-/, "/").replace(/-/, "/");
            if (l.StrOutPath) {
              var d = l.StrOutPath;
              d = d.replace('"', "").replace('"', "");
              var path = this.tablePath + d;
              this.$set(l, "path", path);
            }
          });
          this.tableData = res.msg;
          this.totalcount = parseInt(res.totalcount);
        } else {
          this.tableData = [];
          this.totalcount = 0;
        }
        this.listLoading = false;
      });
    },
    // 清除定时器的代码
    clear() {
      clearInterval(this.interval);
      this.interval = null;
    },
  },
  beforeDestroy() {
    // 在页面销毁后，清除计时器
    this.clear();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


<style >
/* .expRecordTable .el-table td {
  padding: 5px 0;
}
.expRecordTable .el-table th {
  padding: 10px 0;
} */
.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}

.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.p_roster_table.el-tabs--card {
  background-color: #fff;
  width: 100%;
}
</style>